<template>
  <div class="HeroSecondary">
    <GlideParallax
      v-if="image"
      class="parallax"
      translate-y="10vh"
    >
      <img
        v-if="image && typeof image === 'object'"
        v-bind="image"
        class="image"
      >
      <BaseImage
        v-else-if="image"
        :id="image"
        class="image"
      />
    </GlideParallax>
    <div class="HeroSecondary__blade"/>
    <div class="HeroSecondary__container">
      <TextEpsilon
        v-if="kicker"
        class="kicker"
        v-text="kicker"
      />
      <h1
        v-if="heading"
        class="heading"
        v-text="heading"
      />
      <slot/>
    </div>
  </div>
</template>

<script>
  import LinkCta from './LinkCta';
  import TextEpsilon from './TextEpsilon';

  export default {
    components: {
      LinkCta,
      TextEpsilon,
    },
    props: {
      image: {
        type: [Object, Number, Boolean],
        default: null,
      },
      heading: {
        type: String,
        default: null,
      },
      kicker: {
        type: String,
        default: null,
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .cta {
    color: color(white);
    background-color: color(red);
  }

  .heading {
    @include column;
    color: color(white);
    font-size: 2.8rem;
    font-weight: font-weight(extra-bold);
    letter-spacing: 0.05em;
    text-transform: uppercase;

    .kicker + & {
      margin-top: spacing(delta);
    }

    @include breakpoint(phablet) {
      // margin-left: percentage(1/12);
      font-size: 5.6rem;
    }
  }

  .HeroSecondary {
    position: relative;
    display: flex;
    align-items: flex-end;
    height: 190px;
    padding-bottom: spacing(base-delta);
    background-color: color(slate);
    overflow: hidden;

    @include breakpoint(phablet) {
      height: 450px;
    }
  }

  .HeroSecondary__blade {
    position: absolute;
    top: 0;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: skew(-45deg) translateX(-50%);
    background-color: rgba(color(slate), 0.5);
    box-shadow: 0px 0px 50px inset rgba(0, 0, 0, 0.25)
  }

  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .HeroSecondary__container {
    @include container;
    position: relative;
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;


    // max-width: $max-width;

    @include breakpoint(phablet) {
      padding-right: percentage(1 / 12);
      padding-left: percentage(1 / 12);
    }
  }

  .kicker {
    color: color(white);
    width: 100%;
  }

  .parallax {
    $translate-y: 10vh;

    position: absolute;
    top: -$translate-y;
    left: 0;
    width: 100%;
    height: calc(100% + #{$translate-y * 2});
  }
</style>
